// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__23ANc","label":"LabeledBox_label__1j-D9"};